import { translateKey } from '../../../../../../translate';
import { TableHeader } from '../../../../../elements/common';

export function MedicationsTableHeader(props: {}) {
    return (
        <>
            <TableHeader>{translateKey('common.name')}</TableHeader>
            <TableHeader>{translateKey('medications.dosageInstruction')}</TableHeader>
            <TableHeader align="right">{translateKey('medications.startDate')}</TableHeader>
            <TableHeader align="right">{translateKey('medications.endDate')}</TableHeader>
        </>
    );
}
